<template>
  <div class="wrapper">
    <GlobalHeader v-if="false"/>
    <DriverStatus v-if="user.login.isLogin && user.flag === 1 && dispatch.isLoadedFirst.all" />
    <FirebaseAlert />
    <div :class="[
        s.main,
        !$route.path.includes('login') && user.login.isLogin ? s.hasStatus : '',
        s[`d_${helper.displayDirection}`],
        helper.isNative.app ? s.isNative: '',
      ]"
      v-if="flag.roleChecked">
      <div :class="s.content">
        <router-view />
      </div>
    </div>
    <GlobalFooter v-if="user.login.isLogin && !helper.isNative.app" />

    <LoadingsModal />
    <ContentsModal />
    <MessagesModal />
    <WebSocketReceiver v-if="user.login.isLogin"/>
    <Notice />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ContentsModal, MessagesModal, LoadingsModal } from '@/components/modal';
import Notice from '@/components/notice/index.vue';
import WebSocketReceiver from '@/components/function/WebSocketReceiver.vue';
import {
  GlobalFooter,
  GlobalHeader,
  DriverStatus,
  FirebaseAlert,
} from '@/components/layouts';

export default {
  name: 'App',
  components: {
    ContentsModal,
    MessagesModal,
    LoadingsModal,
    WebSocketReceiver,
    Notice,
    GlobalFooter,
    GlobalHeader,
    DriverStatus,
    FirebaseAlert,
  },
  data() {
    return {
      flag: {
        roleChecked: false,
        nativeApp: {
          sendedUserInfo: false,
        },
      },
      nativeStoreVehicleId: null,
    };
  },
  computed: {
    ...mapState(['user', 'modal', 'helper', 'dispatch']),
    demandAreaIds() {
      if (this.user.driverDemandAreas?.length) {
        return this.user.driverDemandAreas.map((a) => a.id);
      }
      return this.user.offices?.map((o) => o.demandAreas.map((a) => a.id)).flat() || [];
    },
    hasDemandAreas() {
      return this.demandAreaIds.length > 0;
    },
  },
  watch: {
    user: {
      handler() {
        this.checkRole();
        this.runDailyCheck();
        this.sendUserInfo4NativeApp();
        this.checkWorkingStatus();
      },
      deep: true,
      immediate: true,
    },
    demandAreaIds: {
      handler() {
        this.$store.dispatch('helper/getDemandSchedules', this.demandAreaIds);
      },
      deep: true,
    },
    $route: {
      handler(to, from) {
        if (to.path !== from.path) this.flag.roleChecked = false;
        this.checkRole();
        this.sendPath4NativeApp();
        this.checkWorkingStatus();
      },
    },
    'helper.displayDirection': {
      handler() {
        const themaBlue = '#4b9fd0';
        const themaWhite = '#ffffff';
        const color = this.helper.displayDirection === 'vertical' ? themaBlue : themaWhite;
        const metaColor = document.querySelector('meta[name="theme-color"]');
        metaColor.setAttribute('content', color);
      },
    },
    'helper.master': {
      handler() {
        if (this.user.id) this.$store.dispatch('user/setDriverStatus', this.user);
      },
      deep: true,
    },
    'user.offices': {
      handler(offices) {
        const officeId = offices?.[0]?.id;
        if (officeId) this.$store.dispatch('helper/fetchStatusColors', officeId);
      },
      immediate: true,
    },
  },
  mounted() {
    /**
     *  createdだと処理が走らない(?)ためmountedで実行
     */ 
    // ログインチェック
    this.$store.dispatch('user/login/check');
    // デバイス情報チェック
    const ua = navigator.userAgent;
    const [, versionUuid] = ua.split('MITT_APP_ANDROID_');
    const [, uuid] = versionUuid ? versionUuid.split('_') : [null, null];
    this.$store.dispatch('helper/checkDevice', uuid);
    // backend共通マスターデータ取得
    this.$store.dispatch('helper/getMaster');
    // 画面方向を取得
    this.checkDisplaySize();

    window.addEventListener('resize', () => { this.checkDisplaySize(); });
  },
  unmounted() {
    window.removeEventListener('resize', () => { this.checkDisplaySize(); });
  },
  methods: {
    checkDisplaySize() {
      this.$store.dispatch('helper/checkDisplayDirection');
    },
    checkRole() {
      // ログイン不要ページはacceptRoleを設けない
      const acceptRole = this.$route.meta?.acceptRole;
      if (!acceptRole) {
        this.flag.roleChecked = true;
        return;
      }
      // ユーザー情報セットされていなければreturn
      if (!this.user.email && !this.user.serial_id) return;
      // 閲覧権限なし
      if (!acceptRole.includes(this.user.role.role)) {
        alert('このページは閲覧権限がありません。ホームへリダイレクトします。');
        this.$router.push('/');
        return;
      }
      this.flag.roleChecked = true;
    },

    runDailyCheck() {
      const office = this.user.offices?.[0];
      if (!office) return;

      // 呼気チェック済みか確認
      const requireAlcoholCheck = office.require_alcohol_check;
      const driverAlcoholLevel = this.user.driverDailyCheck?.alcohol_level;
      const hasAlcoholLevel = Number(driverAlcoholLevel) || Number(driverAlcoholLevel) === 0;
      if (requireAlcoholCheck && !hasAlcoholLevel) {
        // アルコールチェックモーダルを開く
        const args = {
          modalName: 'DriverDailyCheck',
          modalTitle: '運行前チェック',
          data: {
            user_id: this.user.id,
          },
        };
        this.$store.dispatch('modal/contents/showModal', args);
      }
    },

    /** ネイティブアプリへパスを送る */
    sendPath4NativeApp() {
      if (this.helper.isNative.app) {
        const native = this.helper.isNative;
        const data = {
          fullPath: this.$route.fullPath,
          path: this.$route.path,
          // query: this.$route.query,
          hash: this.$route.hash,
          name: this.$route.name,
          // params: this.$route.params,
        };
        if (native.android) {
          // androidの処理
          const Android = window.Android;
          Android.jsToAndroid(JSON.stringify(data));
        } else if (native.iOS) {
          // iOSの処理
          console.log('isiOS');
        }
      }
    },

    /** Nativeへユーザー情報を渡す */
    sendUserInfo4NativeApp() {
      // store登録されており(user.idがあり)、初回またはネイティブ
      if (!this.user.id || (!this.flag.nativeApp.sendedUserInfo && this.user.vehicles?.[0]?.id === this.nativeStoreVehicleId)) return;

      if (this.helper.isNative.app) { // ネイティブアプリに限る
        const native = this.helper.isNative;
        const data = {
          user_id: this.user.id,
          email: this.user.email,
          username: this.user.username,
          serial_id: this.user.serial_id,
          // user.vehiclesは[0]が現在乗っている車両になる
          vehicle_id: this.user.vehicles?.[0]?.id,
          office_id: this.user.offices[0].id,
        };
        if (native.android) {
          // androidの処理
          const Android = window.Android;
          Android.jsToAndroid(JSON.stringify(data));
        } else if (native.iOS) {
          // iOSの処理
          console.log(this.helper.isNative);
        }

        // 送信したvehicleIdを保持
        this.nativeStoreVehicleId = this.user.vehicles?.[0]?.id || null;
        // 重複して送るのを避ける
        this.flag.nativeApp.sendedUserInfo = true;
      }
    },

    checkWorkingStatus() {
      // 業務終了ステータスの場合、ホームにリダイレクト
      if (this.user.login.isLogin && this.user?.flag !== 1 && this.$route.path !== '/') this.$router.push('/');
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_fonts.scss';
@import '@/assets/scss/_variables.scss';
@import './assets/scss/_reset.scss';
@import './assets/scss/_mq.scss';
@import './assets/scss/modal.scss';
@import './assets/scss/style.scss';
</style>

<style lang="scss" module="s">
.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding-bottom: var(--footer-height);
  &.hasStatus {
    padding-top: var(--page-label-height);
  }
  .content {
    min-height: 100%;
    overflow: scroll;
  }
  &.isNative {
    padding-bottom: 0;
  }
}
</style>
